import React from "react";
import OfficeToPdfConverter from "../../components/OfficeToPdfConverter";

const Excel2Pdf = () => (
  <OfficeToPdfConverter
    documentLabel="Excel"
    title={
      <>
        Convert <b>EXCEL</b> documents to <b>PDF</b>.
      </>
    }
    description="Make your XLS and XLSX files more accessible by converting them to PDF."
    accept=".xls,.xlsx"
    emptyMessage="Please select one or more XLS or XLSX files."
  />
);

export default Excel2Pdf;
